import { Box, Paper } from '@mui/material'
import { VotingCarousel } from './Carousel'
import { VotingControls } from './Controls'
import { Menu } from './Menu'

const layoutStyle = {
  width: '100%',
  display: 'flex',
  flexDirection: 'column'
}

const contentStyle = {
  width: '100%',
  maxWidth: '600px',
  margin: '0 auto',
  padding: '8px'
}

export const FursuitVoting = (props) => {
  const { fursuitVotingData } = props
  return (
    <Box sx={layoutStyle}>
      <Menu {... fursuitVotingData} />
      <Box sx={contentStyle}>
        <Paper sx={{ padding: '5px' }}>
          <VotingCarousel {... fursuitVotingData} />
          <VotingControls {... fursuitVotingData} />
        </Paper>
      </Box>
    </Box>
  )
}
